import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, ref } from "vue";
import { useSharedStore } from "@/store/sharedata";

// 定义主题状态，初始值从 localStorage 获取

export default {
  __name: 'ThemeChange',
  setup(__props) {
    const store = useSharedStore();
    const themePage = ref(store.theme || "light");

    // 切换主题函数
    const toggleTheme = () => {
      themePage.value = themePage.value === "light" ? "dark" : "light";
      store.setTheme(themePage.value); // 保存主题
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createBlock(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: themePage.value === 'light' ? '高亮主题' : '暗夜主题',
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "theme-box-new",
          onClick: toggleTheme
        }, [_createVNode(_component_Icon, {
          class: "icon",
          icon: themePage.value === 'light' ? 'material-symbols:light-mode-rounded' : 'material-symbols:nightlight-badge',
          size: 30
        }, null, 8, ["icon"])])]),
        _: 1
      }, 8, ["content"]);
    };
  }
};